import uuid from 'uuid/v4';
import noop from 'lodash/noop';

import createAction from './';

export const ADD_TOAST = createAction('ADD_TOAST');
export const UPDATE_TOAST = createAction('UPDATE_TOAST');

/**
 * [addToast description]
 *
 * @param {string} messageType visual type of the message
 * @param {string} testId param will used in automation tests
 * @param {Object|string} message text that would be displayed in toast
 * @param {boolean} showClose control displaying of close button
 * @param {boolean} showRetry control displaying of retry button
 * @param {function} onRetry callback on clicking retry button
 * @param {boolean} showUndo control displaying of undo button
 * @param {function} onUndo callback on clicking undo button
 * @param {number} autoDismissTime time in milliseconds to remove toast message
 * @param {string} type
 */
export function addToast(
  messageType,
  testId = '',
  message,
  showRetry = false,
  onRetry = noop,
  showClose = true,
  showUndo = false,
  onUndo = noop,
  autoDismissTime = 6000,
  type = 'app',
) {
  return (dispatch, getState) => {
    const { messageSystem: { toasts } } = getState();

    const meta = {
      id: uuid(),
      message,
      testId,
      type: messageType,
      showClose,
      showRetry,
      onRetry,
      showUndo,
      onUndo,
      autoDismissTime,
      hasDuplicate: 0,
    };

    const foundItem = toasts.list.find(item => item.message.id === meta.message.id);

    return dispatch(
      !foundItem ? {
        type: `${ type }_${ ADD_TOAST }`,
        payload: meta,
      } : {
        type: `${ type }_${ UPDATE_TOAST }`,
        payload: {
          ...foundItem,
          hasDuplicate: foundItem.hasDuplicate + 1,
        },
      },
    );
  };
}
